module.exports = __webpack_public_path__ + "static/media/open-sans-semibold.c8696f38.woff2";